import Api from '@/services/api.js';
export default {
  register(credentials) {
    return Api.post('user/register', credentials)
  },
  addUser(credentials) {
    return Api.post('user/', credentials)
  },
  getAllUsers() {
    return Api.get('user/')
  },
  getAllUserAuthClasses() {
    return Api.get('user/userAuthClass')
  },
  deleteUser(user) {
    return Api.delete(`user/${user}`);
  },
  updateUser(user) {
    return Api.put(`user/${user.id}`, user)
  },
  updateUserPassword(user) {
    return Api.put(`user/password/${user.id}`, user)
  }
}